import { render, staticRenderFns } from "./ShipmentBuilder.vue?vue&type=template&id=0d37bcf7&"
import script from "./ShipmentBuilder.vue?vue&type=script&lang=js&"
export * from "./ShipmentBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports